import { StyleSheet } from "@react-pdf/renderer";

const About = () => {
    console.log("About Page Loaded");
     const styles = StyleSheet.create({
       page: {
        flexDirection: "row",
        backgroundColor: "#61dafb",
      }
     });
    return (
        <div style={styles.page}>
            <div>
                <h2 align="center">Internet Software Works</h2>
                <br />
                <h2 align="center">About Tom Erickson</h2>
            </div>
            <div><p>
                I am a senior software engineer with over 20 years of experience
                designing and building enterprise applications across non-emergency
                medical transportation, commercial websites, eCommerce,
                and healthcare solutions. I specialize in full-stack development
                with deep expertise in Java, Spring Boot, RESTful API design,
                and modern JavaScript frameworks including React and React Native.
            </p></div>
            <div><p>
                Most recently, I contributed to the Modivcare mobile application, a React Native platform that enables members to schedule Non-Emergency Medical Transportation (NEMT). My primary role was backend development using Spring Boot, where I created RESTful endpoints, designed MySQL schema, and integrated legacy systems. I implemented the Preferred Provider feature—designing new database tables, building add/delete/reorder functionality, and developing the corresponding React services and UI components. I also delivered the Will Call workflow, which determines transportation assignments based on destination, accessibility needs, and insurance coverage.

            </p></div>
            <div><p>
                Another major contribution to the Modivcare app was integrating the
                Braze marketing platform. I designed large-scale ETL processes to extract
                millions of member records from a legacy DB2 system, transform them into JSON,
                and batch-load them into the Braze API—handling strict throughput limits,
                API instability, and error-recovery scenarios.
            </p></div>
            <div><p>
                Before Modivcare, I worked at DISH on the Sling TV engineering team.
                I helped build microservices in Java/Spring Boot and developed frontend
                features using Angular and React. My work included designing MySQL schemas,
                building user preference services, and developing a React-based home-page
                customization experience. I also helped modernize a legacy Ruby service
                by creating a secure API layer using AWS Lambda (TypeScript/Node), Lambda Authorizers,
                and Route 53 to proxy traffic without requiring client-side changes.
            </p></div>
            <div><p>
                Additionally, I designed and implemented a daily ingestion pipeline that
                pulled sports-broadcast data from Oracle, loaded it into MongoDB, and
                exposed fast API endpoints so Sling users could easily find where sporting
                events were airing. This architecture replaced slow, expensive SQL queries
                with a high-performance NoSQL lookup system.
            </p></div>
            <div><p>
                Across my career, I’ve built scalable backend systems, designed intuitive front-end experiences,
                integrated legacy platforms, and delivered high-impact features used by millions of users.
                I thrive in challenging engineering environments where reliability, performance, and user experience matter.
            </p></div>
            <div align="center">
                <p>Tom Erickson Founder/Principal Consultant </p>
            </div>
        </div>
    );
};
export default About;

